<template>
  <div class="informatives-page">
    <app-page-header title="Notícias">
      <router-link
        :to="{ name: 'informatives.create' }"
        tag="button"
        type="button"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="plus"></b-icon>Novo
      </router-link>
    </app-page-header>

    <informatives-table></informatives-table>
  </div>
</template>

<script>
import InformativesTable from '@/components/Tables/InformativesTable';

export default {
  name: 'informatives-page',
  components: {
    InformativesTable,
  },
};
</script>
